import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { FETCH_REFERENCES, FETCH_REFERENCE, UPDATE_REFERENCE, DELETE_REFERENCE, ADD_REFERENCE, REMOVE_REFERENCE, CLEAR_CACHE, FETCH_ERROR } from './actions.type'
import { SET_REFERENCES, SET_REFERENCES_ERRORS, SET_REFERENCES_LOADING, SET_REFERENCE, SET_REFERENCE_ERRORS, SET_REFERENCE_LOADING, REFERENCES_SORT } from './mutations.type'

const state = {
    references: [],
    referencesErrors: [],	
    referencesIsLoading: false,
    reference: [],
    referenceErrors: [],	
    referenceIsLoading: false
}

const getters = {
    references : state => key => {
        return state.references.filter(x =>
            x.name.toLowerCase().includes(key.toLowerCase()) ||
            (x.title && x.title.toLowerCase().includes(key.toLowerCase())) ||
            x.tags.indexOf(key) >= 0
        )
    },
    referencesErrors (state) {
        return state.referencesErrors
    },
    referencesIsLoading (state) {
        return state.referencesIsLoading
    },
    reference (state) {
        return state.reference
    },
    referenceErrors (state) {
        return state.referenceErrors
    },
    referenceIsLoading (state) {
        return state.referenceIsLoading
    }
}

const actions = {
    [FETCH_REFERENCES] (context, params) {
        context.commit(SET_REFERENCES_LOADING)
        let local_this = this;
        return new Promise((resolve, reject) => {
            ApiService.query('manager/references')
            .then(({data}) => {
                if (typeof data == "object") {
                    context.commit(SET_REFERENCES, data)
                    resolve(data)
                } else {
                    context.commit(SET_REFERENCES_ERRORS, ["Разрыв сессии"])
                }
            })
            .catch((error) => {
                ErrorsService.setFetchError(SET_REFERENCES_ERRORS, context, error)
            })
            .finally(x => {
                context.commit(SET_REFERENCES_LOADING, false)
            })
        })
    },
    [FETCH_REFERENCE] (context, params) {
        context.commit(SET_REFERENCE_LOADING)
        let local_this = this;
        return new Promise((resolve, reject) => {
            ApiService.getBy('manager/references', params.name)
            .then(({data}) => {
                if (typeof data == "object") {
                    context.commit(SET_REFERENCE, data)
                    resolve(data)
                } else {
                    context.commit(SET_REFERENCE_ERRORS, ["Разрыв сессии"])
                }
            })
            .catch((error) => {
                ErrorsService.setFetchError(SET_REFERENCE_ERRORS, context, error)
            })
            .finally(x => {
                context.commit(SET_REFERENCE_LOADING, false)
            })
        })
    },
    [UPDATE_REFERENCE] (context, params) {
        context.commit(SET_REFERENCE_LOADING)
        let local_this = this;
        return new Promise((resolve, reject) => {
            ApiService.put(`manager/references/${params.name}/put`, params.body)
            .then(({data}) => {
                if (typeof data == "object") {
                    context.commit(SET_REFERENCE, data)
                    local_this.dispatch(FETCH_ERROR, { variant: "success", text: "Справочник обновлён", title: "Готово" })
                    resolve(data)
                } else {
                    context.commit(SET_REFERENCE_ERRORS, ["Разрыв сессии"])
                }
            })
            .catch((error) => {
                ErrorsService.setFetchError(SET_REFERENCE_ERRORS, context, error)
            })
            .finally(x => {
                context.commit(SET_REFERENCE_LOADING, false)
            })
        })
    },
    [DELETE_REFERENCE] (context, params) {
        context.commit(SET_REFERENCE_LOADING)
        let local_this = this;
        return new Promise((resolve, reject) => {
            ApiService.delete(`manager/references/${params.name}/delete`)
            .then(({data}) => {
                if (data === true) {
                    context.commit(SET_REFERENCE, data)
                    local_this.dispatch(FETCH_ERROR, { variant: "success", text: "Справочник удалён", title: "Готово" })
                    resolve(data)
                } else {
                    context.commit(SET_REFERENCE_ERRORS, ["Разрыв сессии"])
                }
            })
            .catch((error) => {
                ErrorsService.setFetchError(SET_REFERENCE_ERRORS, context, error)
            })
            .finally(x => {
                context.commit(SET_REFERENCE_LOADING, false)
            })
        })
    },
    [ADD_REFERENCE] (context, params) {
        context.commit(SET_REFERENCE_LOADING)
        let local_this = this;
        return new Promise((resolve, reject) => {
            ApiService.put(`manager/references/${params.layerKey}/${params.fieldKey}/${params.referenceKey}/add`)
            .then(({data}) => {
                if (data === true) {
                    // Успех – сообщается, что справочник прикреплён
                    context.commit(SET_REFERENCE, data)
                    local_this.dispatch(FETCH_ERROR, {
                        variant: "success",
                        text: "Справочник прикреплён",
                        title: "Готово"
                    })
                    resolve(data)
                } else if (typeof data === 'string') {
                    // Java controller возвращает читаемое сообщение об ошибке
                    context.commit(SET_REFERENCE_ERRORS, [data])
                    local_this.dispatch(FETCH_ERROR, {
                        variant: "error",
                        text: data,
                        title: "Ошибка"
                    })
                    reject(new Error(data))
                } else {
                    // Ответ не успешен (400, 500)
                    context.commit(SET_REFERENCE_ERRORS, ["Ошибка сервера"])
                    local_this.dispatch(FETCH_ERROR, {
                        variant: "error",
                        text: "Ошибка сервера",
                        title: "Ошибка"
                    })
                    reject(new Error("Server error"))
                }
            })
            .catch((error) => {
                // Прочие ошибки
                ErrorsService.setFetchError(SET_REFERENCE_ERRORS, context, error)
            })
            .finally(() => {
                context.commit(SET_REFERENCE_LOADING, false)
            })
        })
    },
    [REMOVE_REFERENCE] (context, params) {
        context.commit(SET_REFERENCE_LOADING)
        let local_this = this;
        return new Promise((resolve, reject) => {
            ApiService.delete(`manager/references/${params.layerKey}/${params.fieldKey}/${params.referenceKey}/remove`)
            .then(({data}) => {
                if (data === true) {
                    // Успех – сообщается, что справочник прикреплён
                    context.commit(SET_REFERENCE, data)
                    local_this.dispatch(FETCH_ERROR, { 
                        variant: "success", 
                        text: "Справочник откреплён", 
                        title: "Готово" })
                    resolve(data)
                } else if (typeof data === 'string') {
                    // Java controller возвращает читаемое сообщение об ошибке
                    context.commit(SET_REFERENCE_ERRORS, [data])
                    local_this.dispatch(FETCH_ERROR, {
                        variant: "error",
                        text: data,
                        title: "Ошибка"
                    })
                    reject(new Error(data))
                } else {
                    // Ответ не успешен (400, 500)
                    context.commit(SET_REFERENCE_ERRORS, ["Ошибка сервера"])
                    local_this.dispatch(FETCH_ERROR, {
                        variant: "error",
                        text: "Ошибка сервера",
                        title: "Ошибка"
                    })
                    reject(new Error("Server error"))
                }
            })
            .catch((error) => {
                // Прочие ошибки
                ErrorsService.setFetchError(SET_REFERENCE_ERRORS, context, error)
            })
            .finally(x => {
                context.commit(SET_REFERENCE_LOADING, false)
            })
        })
    },
    [CLEAR_CACHE] (context, params) {
        context.commit(SET_REFERENCE_LOADING)
        let local_this = this;
        return new Promise((resolve, reject) => {
            ApiService.delete(`manager/cache/layer_list/clear`)
            .then(({data}) => {
                if (typeof data == "object") {
                    context.commit(SET_REFERENCE, data)
                    local_this.dispatch(FETCH_ERROR, { variant: "success", text: "Кэш обновлён", title: "Готово" })
                    resolve(data)
                } else {
                    context.commit(SET_REFERENCE_ERRORS, ["Разрыв сессии"])
                }
            })
            .catch((error) => {
                ErrorsService.setFetchError(SET_REFERENCE_ERRORS, context, error)
            })
            .finally(x => {
                context.commit(SET_REFERENCE_LOADING, false)
            })
        })
    }
}

const mutations = {
    [SET_REFERENCES] (state, data) {
        state.references = data
        state.referencesErrors = []
    },
    [SET_REFERENCES_ERRORS] (state, errors) {
        state.references = []
        state.referencesErrors = errors
    },
    [SET_REFERENCES_LOADING] (state, status = true) {
        state.referencesIsLoading = status
    },
    [SET_REFERENCE] (state, data) {
        state.reference = data
        state.referenceErrors = []
    },
    [SET_REFERENCE_ERRORS] (state, errors) {
        state.reference = []
        state.referenceErrors = errors
    },
    [SET_REFERENCE_LOADING] (state, status = true) {
        state.referenceIsLoading = status
    },
    [REFERENCES_SORT] (state) {
        state.references.sort((a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0))
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/references.module.js